'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useConversationContext } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationHeader = /*#__PURE__*/React.forwardRef(function ConversationHeader(props, ref) {
  const {
      children,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = useConversationContext();
  const Header = slots?.header ?? 'div';
  const headerProps = useSlotProps({
    elementType: Header,
    externalSlotProps: slotProps?.header,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Header, _extends({}, headerProps, {
    children: children
  }));
});
if (process.env.NODE_ENV !== "production") ConversationHeader.displayName = "ConversationHeader";